import React from 'react';
import { useRecordContext } from 'react-admin';

const EllipsisTextField = props => {
  const { source } = props;
  const record = useRecordContext(props);
  
  if (!record || !record[source]) return null;
  
  const value = record[source];
  
  return (
    <div className="" style={{ maxWidth: 200}}>
      <span style={{
        display: 'block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        borderBottom: 'none !important'
      }}>
        {value}
      </span>
    </div>
  );
};

export default EllipsisTextField;
